import { render, staticRenderFns } from "./valorMinimo.vue?vue&type=template&id=54f2e2d2&"
import script from "./valorMinimo.vue?vue&type=script&lang=js&"
export * from "./valorMinimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports